import React, { useEffect, useState } from 'react';
import { Avatar, Divider, List, Spin } from 'antd';
import { serverDomain } from "./StaticVar";
import axios from 'axios';
import { LinkOutlined } from '@ant-design/icons';

function UploadedFiles() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        const response = axios.get(serverDomain + "/get").then((response) => {
            setContent(response.data.files);
        });
    }, [])

    return (
        content == null ? <Spin /> :  <List
        size="small"
        header={<div>Files List</div>}
        bordered
        dataSource={content}
        renderItem={(item) => <List.Item><List.Item.Meta
            avatar={<LinkOutlined />}
            title={<a target='_blank' href={`/vedas/?${item}`}>{item}</a>}
            // description="Ant Design, a design language for background applications, is refined by Ant UED Team"
          /></List.Item>}
      />
    )
}

export default UploadedFiles;